import { z } from 'zod';
import { optionnel, optionnelNombre, DATE_ISO } from '@shared/validation/helpers';
import {
  nifGabon,
  numeroCnss,
  numeroCnamgs,
  rccmGabon,
  telephoneGabon,
} from '@shared/validation/identifiantsGabon';

export const EntrepriseIdentiteSchema = z
  .object({
    nom: z.string().min(1, 'Raison sociale requise').max(200),
    code: optionnel(z.string().max(20)),
    // NIF et RCCM : obligatoires, mais sans aucun contrôle de format.
    nif: nifGabon,
    rccm: rccmGabon,
    numero_cnss_employeur: optionnel(numeroCnss),
    numero_cnamgs_employeur: optionnel(numeroCnamgs),
    adresse: optionnel(z.string().max(300)),
    ville: optionnel(z.string().max(100)),
    telephone: optionnel(telephoneGabon),
    email: optionnel(z.string().email('Email invalide')),
    secteur_activite: optionnel(z.string().max(200)),
    periode_courante: optionnel(z.string().regex(/^\d{4}-\d{2}$/, 'Période AAAA-MM')),
    forme_juridique: optionnel(z.string().max(20)),
    capital_social: optionnelNombre(z.number().min(0)),
    date_creation: optionnel(z.string().regex(DATE_ISO, 'Date YYYY-MM-DD')),
    convention_collective: optionnel(z.string().max(120)),
  })
  .superRefine((data, ctx) => {
    if (data.date_creation && data.date_creation > new Date().toISOString().slice(0, 10)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['date_creation'],
        message: 'La date de création ne peut pas être dans le futur',
      });
    }
  });

export type EntrepriseIdentiteInput = z.infer<typeof EntrepriseIdentiteSchema>;
